/**
 * Here you implement your functions you want to use everywhere in your application.
 * See this functions as an example.
 */

import { yTickLabels } from './constants';

export const DEBUG = true;

export function log(...args) {
  if (!DEBUG) {
    return false;
  }

  return console.log(args);
}

export function isUndefined(obj) {
  return typeof obj === 'undefined';
}

export function isNumeric(number) {
  if (isUndefined(number)) {
    return false;
  }

  return !isNaN(number) && isFinite(number);
}

/**
 * [numberFormat format number to loacle string]
 * @param  {[type]} number
 * @param  {String} [countyCode='de-De']
 * @param  {Object} [options={}]         [https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString]
 * @return {String}
 */
export function numberFormat(number, lang = 'de', digits = 0) {
  if (!isNumeric(number) || isUndefined(Number.toLocaleString())) {
    return false;
  }
  return number.toLocaleString(lang, { minimumFractionDigits: digits, maximumFractionDigits: digits });
}

// device helper
// smartphone detection (android,iphone,blackberry,windows phone)
export const isSmartphone = /android.*mobile|mobile.*android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
export const isTablet = !isUndefined(window.orientation) && window.innerWidth === 768;
export const isTouch = !isUndefined(window.orientation);
export const isDesktop = window.innerWidth > 768;


// device depending click event
export const clickEvent = isTouch ? 'touchstart' : 'click';

// ie helper
function detectIE() {
  const ua = window.navigator.userAgent;
  const msIE = ua.indexOf('MSIE ');
  if (msIE > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msIE + 5, ua.indexOf('.', msIE)), 10);
  }

  const trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    const rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  const edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }
  // other browser


  return false;
}

const version = detectIE();
export const isOldIE = version && version < 12;

export function getHighlightIndex(val) {
  if (!val) {
    return null;
  } else if (val <= 200) {
    return 0;
  } else if (val > 6000) {
    return yTickLabels.length - 1;
  } else if (val % 200 === 0) {
    return Math.floor((val - 1) / 200);
  }

  return Math.floor(val / 200);
}

export function parseQueryString() {
  const query = window.location.search.substring(1);
  const langIndex = query.indexOf('lang');

  if (langIndex !== -1) {
    const pair = query.split('=');
    return pair[1];
  }
  return false;
}

// from d3-ease
export function quadOut(t) {
  return t * (2 - t);
}

export default {
  log,
  isUndefined,
  isNumeric,
  numberFormat,
  isSmartphone,
  isTablet,
  isDesktop,
  isTouch,
  clickEvent,
  isOldIE,
  getHighlightIndex,
  quadOut
};



// WEBPACK FOOTER //
// ./src/helper/utils.js